import { resetRemunerationModeAction } from 'modules/remunerationModeNavigation/actions';

import { REMUNERATION_CONTAINERS_LIST } from 'shared/enums';

export const clearNavigationActions = {
  [REMUNERATION_CONTAINERS_LIST.FLOW]: resetRemunerationModeAction,
};
